import { inject, type InjectionKey } from "vue";
import type {
    IPhieuXuatKhoSuppliesQuantityRow,
    PhieuXuatKhoLoaiPhieu,
    PhieuXuatKhoTableRow,
} from "../types";
import type { PhieuXuatKhoTableColumnContext } from "./usePhieuXuatKhoTableColumns";

export type { PhieuXuatKhoTableColumnId } from "./usePhieuXuatKhoTableColumns";

export interface PhieuXuatKhoTableCellApi {
  isSummaryMode: boolean;
  readonly: boolean;
  loaiPhieu: PhieuXuatKhoLoaiPhieu;
  columnContext: PhieuXuatKhoTableColumnContext;
  pickTotalAmount: number;
  pickTotalText: string;
  formatQuantity: (value: number) => string;
  formatUnitPrice: (value: number) => string;
  formatAmount: (value: number) => string;
  calcThanhTien: (donGia: number, soLuong: number) => number;
  calcThanhTienTotal: (
    lines: { don_gia: number; so_luong_lay: number }[]
  ) => number;
  getQuantityRowByVatTuId: (
    idVatTu: number
  ) => IPhieuXuatKhoSuppliesQuantityRow | undefined;
  getQuantityMin: (idVatTu: number) => number;
  getDonGia: (idVatTu: number) => number;
  canEditQuantity: (idVatTu: number) => boolean;
  calcRemainingNeed: (idVatTu: number) => string;
  thanhTienCalc: (idVatTu: number) => string;
  onQuantityFocus: (idVatTu: number, event: FocusEvent) => void;
  onQuantityBlur: (idVatTu: number) => void;
  onQuantityChange: (idVatTu: number, value: unknown) => void;
  onMatBlur: (idVatTu: number) => void;
  onMatChange: (idVatTu: number, value: unknown) => void;
  onPheLieuBlur: (idVatTu: number) => void;
  onPheLieuChange: (idVatTu: number, value: unknown) => void;
  onQuyDoiBlur: (idVatTu: number) => void;
  onQuyDoiChange: (idVatTu: number, value: unknown) => void;
  isVatTuThuHoi: (idVatTu: number) => boolean;
  canEditThuHoiFields: (idVatTu: number) => boolean;
  emitQuantityChange: () => void;
  emitDeleteItem: (idVatTu: number) => void;
}

export const PHIEU_XUAT_KHO_TABLE_CELL_API_KEY: InjectionKey<PhieuXuatKhoTableCellApi> =
  Symbol("PhieuXuatKhoTableCellApi");

export type PhieuXuatKhoThuHoiSubColumnId =
  | "tai_sd"
  | "mat"
  | "so_luong_phe_lieu"
  | "quy_doi_kg"
  | "ma_vt_thu_hoi";

export function isFooterRow(row: PhieuXuatKhoTableRow) {
  return !!row._footerType;
}

export function usePhieuXuatKhoTableCellApi(): PhieuXuatKhoTableCellApi {
  const api = inject(PHIEU_XUAT_KHO_TABLE_CELL_API_KEY);

  if (!api) {
    throw new Error("PhieuXuatKhoTableCellApi is not provided");
  }

  return api;
}
